import { observer } from 'mobx-react-lite';

import classes from './GameOverlay.module.css';
import clsx from 'clsx';

const GameOverlay = ({light = false}) => {


  return (
    //<div className={classes.GameOverlay} />
    <div className={clsx(classes.GameOverlay, light && classes.light)} />
  );
};
    
export default observer(GameOverlay);